// Google验证码使用说明页面翻译
export default {
  title: "如何使用谷歌验证码",
  intro:
    "身份验证器，通常指一种软件或硬件工具，用于生成一次性的、短时间有效的验证码，作为登录账户时的第二道安全凭证。它的主要目的是为了双因素认证或多因素认证。您可以把它理解为一个不断生成动态密码的“电子令牌”或“数字钥匙”。使用身份验证器的整个过程可以分为两大步：",

  // 微信小程序使用方式
  wechatMethod: {
    title: "1、微信小程序",
    step1: '第一步：在微信搜索"腾讯身份验证器"或者"宁盾令牌"进入小程序',
    step2: "第二步：请将小程序中你绑定的动态数字输入验证码输入框",
  },

  // 手机App使用方式
  appMethod: {
    title:
      "2、手机宁盾令牌（iOS和Android手机用户）或者google authenticator（仅限iOS手机用户）",
    step1: "第一步：在App Store或者安卓应用市场搜索对应app然后下载",
    step2: "第二步：请将 App中你绑定的动态数字输入验证码输入框",
  },
};
